import React, { useEffect, useState } from 'react';
import Modal from 'antd/lib/modal';
import Input from 'antd/lib/input';
import Button from 'antd/lib/button';
import Checkbox from 'antd/lib/checkbox';
import editIcon from '../assets/edit.svg';

// ICONS
import searchIcon from '../../../../../../icons/search.svg';
import searchDarkIcon from '../../../../../../icons/search-dark.svg';

import './MonitoringModal.less';

export const MonitoringModal = (props) => {
  const { Search } = Input;
  const { onCancel, saveChanges, categoryDataPoints, theme, selectedCategory } = props;
  const [filteredDataPointsList, setFilteredDataPointsList] = useState([]);
  const [sortValue, setSortValue] = useState('display_name');
  const [searchValue, setSearchValue] = useState('');
  const [isReversed, setIsReversed] = useState(false);
  const [selectedDataPoints, setSelectedDataPoints] = useState([]);
  const themedSearchIcon = theme === 'dark' ? searchDarkIcon : searchIcon;

  const handleCheckboxChange = (tag) => {
    let tmpSelectedDataPoints = selectedDataPoints;
    if (!tmpSelectedDataPoints.includes(tag)) {
      // checking new data point
      tmpSelectedDataPoints = [...tmpSelectedDataPoints, tag];
    } else {
      tmpSelectedDataPoints = tmpSelectedDataPoints.filter((item) => item !== tag);
    }

    if (tmpSelectedDataPoints.length) {
      sessionStorage.setItem('clearData', false);
    } else {
      sessionStorage.setItem('clearData', true);
    }
    setSelectedDataPoints(tmpSelectedDataPoints);
  };

  const clearAllPoints = () => {
    sessionStorage.setItem('clearData', true);
    setSelectedDataPoints([]);
  };

  const renderModalItems = () => {
    return (
      <div className="modal__items">
        {filteredDataPointsList.map((dataPoint) => {
          const { status, display_name: displayName, tag } = dataPoint;
          const dataPointClass = 'modal__column';
          const desktopClass = ' modal__column--desktop ';
          const isSelected = selectedDataPoints.includes(tag);
          const selectedItemClass = isSelected
            ? 'modal__registry-item modal__registry-item--selected'
            : 'modal__registry-item';

          return (
            <label htmlFor={tag} key={tag}>
              <div className={selectedItemClass}>
                <div className={`${dataPointClass} ${dataPointClass}-select`}>
                  <Checkbox
                    className={`app-checkbox-${theme}`}
                    id={tag}
                    checked={isSelected}
                    onChange={() => handleCheckboxChange(tag)}
                  />
                </div>
                <div className={`${dataPointClass} modal__column--wide`}>{displayName}</div>
                <div className={`${dataPointClass} ${dataPointClass}-status ${desktopClass} desktop`}>{status}</div>
              </div>
            </label>
          );
        })}
      </div>
    );
  };

  const updateSortValue = (value) => {
    const reversed = value === sortValue && !isReversed;

    setSortValue(value);
    setIsReversed(reversed);
  };

  useEffect(() => {
    const customDataPoints = JSON.parse(sessionStorage.getItem('customDataPoints'));

    if (customDataPoints && customDataPoints.length) {
      setSelectedDataPoints(customDataPoints);
    } else {
      let tmpSelectedDataPoints = [];

      if (selectedCategory === 'All') {
        categoryDataPoints.map((dataPoint) => {
          if (dataPoint.tag === 'CLDOAT') {
            tmpSelectedDataPoints = [...tmpSelectedDataPoints, dataPoint.tag];
          }

          return tmpSelectedDataPoints;
        });
      } else {
        categoryDataPoints.map((dataPoint) => {
          if (dataPoint.is_default) {
            tmpSelectedDataPoints = [...tmpSelectedDataPoints, dataPoint.tag];
          }

          return tmpSelectedDataPoints;
        });
      }

      setSelectedDataPoints(tmpSelectedDataPoints);
    }
  }, [categoryDataPoints]);

  useEffect(() => {
    let tempRegisterList = categoryDataPoints;

    if (searchValue) {
      tempRegisterList = tempRegisterList.filter((item) =>
        item.display_name.replace(/\s/g, '').toLowerCase().includes(searchValue.replace(/\s/g, '').toLowerCase()),
      );
    } else {
      tempRegisterList = categoryDataPoints;
    }

    if (sortValue === 'display_name') {
      // if this is the first time sorting, or if the previous sort is not by display_name
      if (!isReversed) {
        tempRegisterList = tempRegisterList.sort((a, b) => {
          if (a.display_name < b.display_name) return -1;
          if (a.display_name > b.display_name) return 1;
          return 0;
        });
      } else {
        // previous sort is also by display_name, we will sort in reverse
        tempRegisterList = tempRegisterList.sort((a, b) => {
          if (a.display_name > b.display_name) return -1;
          if (a.display_name < b.display_name) return 1;
          return 0;
        });
      }
    }

    setFilteredDataPointsList(tempRegisterList, () => {
      renderModalItems();
    });
  }, [searchValue, sortValue, isReversed]);

  const modalColumnClass = 'modal__column-name';

  return (
    <Modal
      className={`monitoring-modal monitoring-modal-${theme}`}
      visible
      closable
      keyboard
      maskClosable
      centered
      title="Add / Remove Lines"
      onCancel={onCancel}
      onOk={() => saveChanges(selectedDataPoints)}
    >
      <div className="modal-content">
        <div className="modal-search">
          <Search
            id="search"
            placeholder="Search Data Set"
            style={{ height: '100%' }}
            onChange={(e) => {
              e.persist();
              setSearchValue(e.target.value);
            }}
            onSearch={(e) => {
              e.persist();
              setSearchValue(e.target.value);
            }}
            prefix={<img src={themedSearchIcon} alt="search icon" />}
          />
        </div>
        <div className="monitoring-details-card__button-wrapper">
          <Button block size="medium" className="monitoring-details-card__button" onClick={() => clearAllPoints()}>
            <div className="monitoring-details-card__buton-text">
              <img className="edit-img" src={editIcon} alt="edit-icon" />
              Clear all points
            </div>
          </Button>
        </div>
        <div className="modal__column-name-wrapper">
          <button
            className={
              sortValue === 'selected'
                ? `${modalColumnClass}-select ${modalColumnClass} modal__column-name--selected`
                : `${modalColumnClass}-select ${modalColumnClass}`
            }
            onClick={() => updateSortValue('selected')}
          >
            <span className="modal__column-name-text">Selected</span>
          </button>
          <button
            className={
              sortValue === 'display_name'
                ? `${modalColumnClass} modal__column-name--wide modal__column-name--selected`
                : `${modalColumnClass} modal__column-name--wide`
            }
            onClick={() => updateSortValue('display_name')}
          >
            <span className="modal__column-name-text">Data Set</span>
          </button>
          <div className={`${modalColumnClass}-status desktop`}>
            <span className="modal__column-name-text">Latest Reading</span>
          </div>
        </div>
        {renderModalItems()}
      </div>
    </Modal>
  );
};
